import { toast as sonnerToast } from 'sonner';
import i18n from '@/i18n';
import { ApiError, isApiError } from './apiError';

export const toast = {
  success: (msg: string) => sonnerToast.success(msg),
  error: (msg: string) => sonnerToast.error(msg),
  info: (msg: string) => sonnerToast.info(msg),
};

export function toastApiError(err: unknown, fallbackKey = 'errors.generic'): void {
  if (isApiError(err)) {
    const key = `errors.${err.code}`;
    const translated = i18n.t(key);
    const message = translated === key ? err.message : translated;
    toast.error(message);
    return;
  }
  if (err instanceof Error && err.message === 'Failed to fetch') {
    toast.error(i18n.t('errors.network'));
    return;
  }
  toast.error(i18n.t(fallbackKey));
}

export function apiErrorMessage(err: unknown, fallbackKey = 'errors.generic'): string {
  if (isApiError(err)) {
    const key = `errors.${err.code}`;
    const translated = i18n.t(key);
    return translated === key ? err.message : translated;
  }
  if (err instanceof Error) return err.message;
  return i18n.t(fallbackKey);
}

export type { ApiError };
